// Custom elements
import previewElement from "./preview";

customElements.define(previewElement.name, previewElement.clazz);
